<template>
  <div v-if="open" class="overlay" @click.self="$emit('close')">
    <section class="modal-card" :class="toneClass">
      <div class="eyebrow">Confirmar</div>
      <h3>{{ title }}</h3>
      <p>{{ description }}</p>

      <div class="actions">
        <button type="button" class="ghost-btn" :disabled="loading" @click="$emit('close')">Cancelar</button>
        <button type="button" class="confirm-btn" :class="toneClass" :disabled="loading" @click="$emit('confirm')">
          <span>{{ loading ? 'Procesando…' : confirmLabel }}</span>
        </button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ConfirmActionModal',
  props: {
    open: { type: Boolean, default: false },
    title: { type: String, default: 'Confirmar acción' },
    description: { type: String, default: '' },
    confirmLabel: { type: String, default: 'Confirmar' },
    loading: { type: Boolean, default: false },
    tone: { type: String, default: 'danger' },
  },
  emits: ['close', 'confirm'],
  computed: {
    toneClass() {
      return ['danger', 'neutral'].includes(this.tone) ? this.tone : 'danger';
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  inset: 0;
  z-index: 120;
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(12px);
  display: grid;
  place-items: center;
  padding: 18px;
}
.modal-card {
  width: min(100%, 460px);
  padding: 22px;
  border-radius: 26px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(148, 163, 184, 0.18);
  box-shadow: 0 26px 60px rgba(15, 23, 42, 0.2);
  display: grid;
  gap: 12px;
}
.eyebrow {
  font-size: 12px;
  font-weight: 800;
  letter-spacing: .08em;
  text-transform: uppercase;
  color: #64748b;
}
h3 {
  margin: 0;
  font-size: 24px;
  line-height: 1.1;
  color: #0f172a;
}
p {
  margin: 0;
  color: #475569;
  line-height: 1.55;
}
.actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 6px;
}
.ghost-btn,
.confirm-btn {
  border: none;
  border-radius: 16px;
  padding: 12px 16px;
  font-weight: 800;
  cursor: pointer;
}
.ghost-btn {
  background: rgba(241, 245, 249, 0.96);
  color: #0f172a;
}
.confirm-btn {
  color: #fff;
}
.confirm-btn.danger {
  background: linear-gradient(135deg, #dc2626, #be123c);
}
.confirm-btn.neutral {
  background: linear-gradient(135deg, #0f172a, #334155);
}
.ghost-btn:disabled,
.confirm-btn:disabled {
  opacity: .6;
  cursor: not-allowed;
}
@media (max-width: 640px) {
  .modal-card {
    padding: 18px;
    border-radius: 22px;
  }
  .actions {
    grid-template-columns: 1fr 1fr;
    display: grid;
  }
  .ghost-btn,
  .confirm-btn {
    width: 100%;
  }
}
</style>
